import { Component, Input, OnInit } from '@angular/core';
import { L10nModule } from '@softline/ui-core';

@Component({
  selector: 'soft-dynamic-date-value',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css'],
  imports: [L10nModule],
})
export class DateComponent implements OnInit {
  @Input() value?: any;
  @Input() format?: string;

  constructor() {}

  ngOnInit(): void {}
}
